import { errorToString, logErrorApi } from '@/utils/common';
import { useEffect } from 'react';
import { Link, useLoaderData, useRouteError } from 'react-router-dom';

const NotFound = () => {
  const error = useRouteError();
  const data = useLoaderData();

  useEffect(() => {
    if (error) {
      logErrorApi(
        data?.roomId || 0,
        1,
        data?.userId || '-',
        'Runtime error in error boundary',
        `${(error as ErrorEvent)?.message} ${window.location.href} ${!error ? '' : typeof error === 'object' ? errorToString(error || {}) : JSON.stringify(error)}`
      );
    }
  }, [data?.roomId, data?.userId, error]);

  return (
    <div className="m-auto flex flex-col items-center justify-center">
      <img
        className="mb-8 h-auto w-full max-w-md p-4"
        src="/images/404-page-dweb.webp"
        alt="404 Not Found"
      />
      <div className="ftext-2xl font-semibold md:text-3xl">Sorry, we could not find that page!</div>
      <Link className="mt-4 rounded-lg bg-blue-500 px-20 py-1 text-white" to="/">
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
